:host {
  width: 100%;
  height: auto;
  position: relative;
}

.vsr-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;

  &.has-poster::before,
  &.show-poster::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: var(--vsr-video-poster);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
    cursor: pointer;
  }

  &.error::before {
    animation: none;
    transform: none;
  }

  &.show-poster .vsr-video,
  &.has-poster .vsr-video {
    opacity: 0;
    pointer-events: none;
  }
}

@keyframes posterZoom {
  to {
    transform: scale(1);
  }
}

.vsr-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;

  &::-webkit-media-controls,
  &::-webkit-media-controls-panel,
  &::-webkit-media-controls-play-button,
  &::-webkit-media-controls-start-playback-button {
    display: none !important;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
  }
}
